import template from './subcontract-details.html';
import controller from './subcontract-details.controller';

let subcontractDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default subcontractDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontract-details/subcontract-details.component.js